export type ChevronIconProps = React.SVGProps<SVGSVGElement>;

export function ChevronIcon(props: ChevronIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M19.696 17.7069L13.936 11.9469L12.1207 10.1898L10.3054 11.9469L4.54543 17.7069L1.96216 15.1236L12.1207 5L22.2443 15.1236L19.696 17.7069Z"
        fill="currentColor"
      />
    </svg>
  );
}
